import type { HTMLAttributes, KeyboardEventHandler } from 'react';
import { forwardRef } from 'react';

import { InnerInput } from '@/core/components/inputs/TextInput/InnerInput';
import useTextInput from '@/core/hooks/inputs/useTextInput';
import type { NewInputProps } from '@/core/types/components';
import { UserSearchesSearchResult } from '@/core/types/donation';

interface NewTextInputProps extends NewInputProps<string> {
  type?: 'text' | 'email';
  autoComplete?: 'name' | 'email' | 'username' | 'address-level2' | 'off';
  inputMode?: HTMLAttributes<HTMLInputElement>['inputMode'];
  noCheck?: boolean;
  userSearches?: UserSearchesSearchResult[];
  handleOnKeyDown?: KeyboardEventHandler;
  hideCleanIcon?: boolean;
}

const NewTextInput = forwardRef<HTMLInputElement, NewTextInputProps>((props, forwardedRef) => {
  const {
    props: { type, autoComplete, inputMode, enterKeyHint, handleOnKeyDown },
    ...attrs
  } = useTextInput<NewTextInputProps>({ forwardedRef, ...props });

  return (
    <div className="relative w-full">
      <InnerInput {...attrs} type={type} autoComplete={autoComplete} inputMode={inputMode} enterKeyHint={enterKeyHint} onKeyDown={handleOnKeyDown} noCheck={props.noCheck} />
    </div>
  );
});

export default NewTextInput;
